import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  month: '',
  content_vi: '',
  content_en: '',
  content_jp: '',
  search: '',
  status: '',
};
export const promotionItemSlice = createSlice({
  name: 'promotion',
  initialState,
  reducers: {
    setItem: (state, action) => {
      const { name, value } = action.payload;
      state[name] = value;
    },
    setDefaultValue: (_, action) => {
      if (!action?.payload?.id) return initialState;
      return { ...action.payload };
    },
    resetData: () => {
      return initialState;
    },
  },
});
export const { setItem, setDefaultValue, resetData } = promotionItemSlice.actions;

export default promotionItemSlice.reducer;
